<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/epR1FhZPpioh1hTp-orTiA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989233818086.jpg" alt="冯文滔受邀出席2023第二届宝船国际文化节" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/20<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">冯文滔受邀出席2023第二届宝船国际文化节</div>
                                <div class="desc">10月20日，2023第二届宝船国际文化节在澳门威尼斯人金光会展隆重启幕。融贯国际董事长冯文滔先生受邀参加圆桌论坛《从澳门到全球，中国茶的国际化品牌之路》。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/1bKkG3D-v2XkD5feo_2xaA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989160474828.jpg" alt="跨界链想 未来无限｜澳门地区首个非遗数字藏品线下专场拍卖预展开幕" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/17<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">跨界链想 未来无限｜澳门地区首个非遗数字藏品线下专场拍卖预展开幕</div>
                                <div class="desc">10月17日，由澳门质量品牌国际认证联盟主办，融贯国际和澳门宝顺拍卖联合呈现的“2023盛世数藏-非遗藏品数字展拍会”预展，于澳门壹号广场二楼211店正式开启。作为目前澳门地区首个大规模的非遗数字藏品线下专场拍卖预展，本次预展受到了澳门市民日报、澳门日报等媒体的关注。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/3K4sVnOriRBvtUeq5TeNPw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1695363735754233.png" alt="携手“三连冠”老字号宝生园 绽放澳门！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/22<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">携手“三连冠”老字号宝生园 绽放澳门！</div>
                                <div class="desc">融贯国际正式与广州市宝生园股份有限公司签署战略合作协议，百年品牌宝生园携手澳优码，探索蜂产品行业链网协同创新应用、数字化管理建设等方面务实合作，实现共赢发展。宝生园是“三连冠”老字号，即国家、省、市老字号“三连冠”品牌。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/F6VBezBMZAt_Q-lOO4zOjw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1695363679960276.png" alt="广州老字号胚芽世家“精力沛”携手澳优码" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/21<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">广州老字号胚芽世家“精力沛”携手澳优码</div>
                                <div class="desc">精力沛作为已有50多年历史的“广州老字号”，在营养保健食品和高品质营养主食的研发、生产和销售中有着丰富的经验，为了有效支撑并落地健康食品产业工业互联网项目，同步规划、有序建设食品产业生态圈，更好地助力老字号企业数字化转型，融贯国际与广州萃取生物科技有限公司建立了全方位、多领域的战略合作伙伴关系。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/sbFTC_yCM3QjhOlDcRkUsA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694959318423201.jpg" alt="澳门数字力量助力昭平乡村振兴" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/17<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门数字力量助力昭平乡村振兴</div>
                                <div class="desc">9月17日下午，第 20 届中国—东盟博览会项目集中签约活动在广西南宁举行。融贯云洲（珠海横琴）数字科技有限公司总经理陈祥代表参加项目集中签约活动。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/73ONCxJp625rmnUQziRBAg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694765256440178.jpg" alt="澳优码亮相首届粤港澳大湾区发展工商大会 “澳门倡议”指导融贯贡献数字力量" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/14<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳优码亮相首届粤港澳大湾区发展工商大会 “澳门倡议”指导融贯贡献数字力量</div>
                                <div class="desc">9月14日，由中国国际贸易促进委员会、广东省人民政府、香港特区政府及澳门特区政府共同主办的粤港澳大湾区发展工商大会开幕，透过会议搭建海内外工商界深入参与粤港澳大湾区的平台，促进合作共赢。融贯国际总经理陈祥携澳优码代表参加会议，希冀在粤港澳大湾区建设进程中贡献融贯数字力量。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/XouV2acVrwJDKRMt5S9IfA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694169157881521.png" alt="澳门融贯受邀出席第四届中国—蒙古国博览会第二届中蒙国际标准化论坛" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/07<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯受邀出席第四届中国—蒙古国博览会第二届中蒙国际标准化论坛</div>
                                <div class="desc">9月7日，第四届中国—蒙古国博览会第二届中蒙国际标准化论坛在呼和浩特开幕。澳门融贯副总经理、粤港澳大湾区认证联盟技术委员会副主任胡永仪等知名专家学者和企业代表受邀出席。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/yxY36NScuFxEYBGN_zim-w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1694168873849664.jpg" alt="澳门代表陈祥受邀出席中国质量（成都）大会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/01<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">澳门代表陈祥受邀出席中国质量（成都）大会</div>
                                <div class="desc">9月1日上午，中国质量（成都）大会在成都开幕。大会以"经济复苏中的质量变革与合作"为主题，由中国国家市场监督管理总局、国家发展和改革委员会、工业和信息化部、四川省人民政府、成都市人民政府等共同主办。融贯国际总经理、澳门质量品牌国际认证联盟秘书长陈祥作为澳门代表受邀参会。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>